
import create from '../utils/create';
import RouterLink from '../mixins/router-link';

export default create({
  render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('a', { staticClass: "van-hairline", class: _vm.b(), attrs: { "href": _vm.url }, on: { "click": _vm.onClick } }, [_c('icon', { class: [_vm.b('icon'), _vm.iconClass], attrs: { "info": _vm.info, "name": _vm.icon } }), _vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2);
  },

  name: 'goods-action-mini-btn',

  mixins: [RouterLink],

  props: {
    url: String,
    text: String,
    info: [String, Number],
    icon: String,
    iconClass: String
  },

  methods: {
    onClick: function onClick(event) {
      this.$emit('click', event);
      this.routerLink();
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/goods-action-mini-btn/index.js
// module id = 226
// module chunks = 80